const Yup = require('yup');

const updateGenericCategory = Yup.object()
  .shape({
    rowsToUpdate: Yup.array()
      .of(
        Yup.object().shape({
          accountJurisdictionId: Yup.string().required(),
          accountId: Yup.string().required(),
          begEndFlag: Yup.string().required(),
          componentId: Yup.string().required(),
          value: Yup.number().required(),
        }),
      )
      .notOneOf([undefined, null]), // eslint-disable-line no-undefined
  })
  .strict();

const updateGenericScreen = Yup.object()
  .shape({
    rowsToUpdate: Yup.array()
      .of(
        Yup.object().shape({
          accountJurisdictionId: Yup.string().required(),
          accountId: Yup.string().required(),
          begEndFlag: Yup.string().required(),
          value: Yup.number().required(),
        }),
      )
      .notOneOf([undefined, null]), // eslint-disable-line no-undefined
  })
  .strict();

module.exports = {
  updateGenericCategory,
  updateGenericScreen,
};
